import React, { FunctionComponent } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Image, Text } from "@chakra-ui/react";

import { NewBadge } from "./NewBadge";
import { ComingSoonBadge } from "./ComingSoonBadge";

export interface TabProps {
	title: string;
	icon: string;
	route: string;
	strictRouteCheck?: boolean;
	isNew?: boolean;
	isComingSoon?: boolean;
}

export const Tab: FunctionComponent<TabProps> = (props) => {
	const navigate = useNavigate();
	const location = useLocation();

	const isActive = props.strictRouteCheck ? location.pathname === props.route : location.pathname.includes(props.route);

	return (
		<Box
			as={Button}
			variant="unstyled"
			rounded="none"
			borderBottomWidth={isActive ? "2px" : "2px"}
			borderColor={isActive ? "var(--primary-color)" : "transparent"}
			height={"56px"}
			display={"flex"}
			alignItems={"center"}
			px={7}
			opacity={props.isComingSoon ? 0.5 : 1}
			cursor={props.isComingSoon ? "not-allowed" : "pointer"}
			onClick={() => {
				if (!props.isComingSoon) navigate(props.route);
			}}
			columnGap={3}
		>
			<Image src={props.icon} width={5} />
			<Text fontWeight={props.isComingSoon || isActive ? "500" : "400"}>{props.title}</Text>
			{props.isNew && <NewBadge />}
			{props.isComingSoon && <ComingSoonBadge />}
		</Box>
	);
};
